<template>
  <section>
    <div class="section-header">
      <h2 class="section-title">{{ title }}</h2>
      <a v-if="link" :href="link" class="section-link">{{ linkText }}</a>
    </div>
    <slot />
  </section>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string;
    link?: string;
    linkText?: string;
  }>(),
  {
    link: undefined,
    linkText: "View All →",
  },
);
</script>

<style scoped lang="scss">
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid var(--color-border);
  padding-bottom: 0.5rem;
}

.section-title {
  margin: 0;
}
</style>
